<div class="confirmation-dialog {{dialogData.cssclass}}">

  @if (dialogData.type == 1) {
    <h1>{{tps.translate('galis_js_Warning')}}</h1>
  }
  @if (dialogData.type == 4) {
    <h1>{{tps.translate('WebGalis_Notification')}}</h1>
  }
  @if (dialogData.type == 3) {
    <h1>{{tps.translate('galis_js_Warning')}}</h1>
  }

  <hr>

    <div class="icon"></div>
    <p class="text">
      {{tps.translate(dialogData.text)}}
    </p>

    @if (dialogData.type == 1) {
      <div class="button-holder">
        <a (click)="confirm()">{{tps.translate('galis_js_GridData_BooleanTrue')}}</a>
        <a (click)="cancel()">{{tps.translate('galis_js_GridData_BooleanFalse')}}</a>
      </div>
    }

    @if (dialogData.type == 3) {
      <div class="button-holder">
        <a (click)="confirm()">{{tps.translate('galis_js_GridData_BooleanTrue')}}</a>
        <a (click)="cancel()">{{tps.translate('galis_js_GridData_BooleanFalse')}}</a>
      </div>
    }

    @if (dialogData.type == 4) {
      <div class="button-holder">
        <a (click)="confirm()">{{tps.translate('galis_js_GridData_Confirm')}}</a>
      </div>
    }

  </div>